import { IMAGES } from "@/lib/images";
import { LuxeLink } from "@/components/LuxeLink";
import { Container, Overline, SectionHeading, Reveal } from "@/components/primitives";

export default function About() {
  return (
    <div className="relative z-10">
      <section className="pt-40 md:pt-52 pb-24">
        <Container>
          <div className="grid lg:grid-cols-12 gap-16 items-center">
            <div className="lg:col-span-6">
              <Reveal>
                <Overline>About VillaFlow</Overline>
                <SectionHeading className="mt-8">More than a concierge. The revenue platform for luxury villas.</SectionHeading>
                <p className="mt-8 text-ivory/65 font-light leading-relaxed">
                  VillaFlow Private Collection is an exclusive hospitality network created for
                  exceptional luxury villas on the Amalfi Coast, the Sorrento Peninsula and Capri —
                  with future expansion to Lake Como, Tuscany, Puglia, Sardinia and beyond.
                </p>
                <p className="mt-5 text-ivory/65 font-light leading-relaxed">
                  We bring together a limited number of properties committed to elevated hospitality
                  and extraordinary guest experiences — particularly for high-spending international
                  guests. The technology behind the experience is VillaFlow; the standard is the Collection.
                </p>
              </Reveal>
            </div>
            <div className="lg:col-span-6">
              <Reveal delay={0.15}>
                <div className="aspect-[4/5] overflow-hidden">
                  <img src={IMAGES.terraceView} alt="Mediterranean villa terrace" className="w-full h-full object-cover" />
                </div>
              </Reveal>
            </div>
          </div>
        </Container>
      </section>

      {/* Privacy */}
      <section className="py-24 bg-navy-800 border-y border-ivory/10" id="privacy" data-testid="privacy-section">
        <Container className="max-w-3xl">
          <Reveal>
            <Overline>Privacy</Overline>
            <h2 className="mt-6 font-serif font-light text-3xl md:text-4xl text-ivory tracking-tight">Privacy Policy</h2>
            <div className="mt-8 space-y-5 text-ivory/60 font-light leading-relaxed text-sm">
              <p>VillaFlow Private Collection collects the information you provide through the application
                process solely to evaluate your property for the Collection. This includes property details,
                management contact information, guest profile information and any images you choose to share.</p>
              <p>Your data is processed on a lawful basis of legitimate interest and consent. It is stored
                securely, is never sold, and is shared only with the VillaFlow Selection Team for the purpose
                of review. Internal assessment notes are confidential and are never shared with applicants.</p>
              <p>You may request access to, correction of, or deletion of your data at any time. By submitting
                an application, you consent to the processing of your personal data as described above, in a
                GDPR-conscious manner.</p>
            </div>
          </Reveal>
        </Container>
      </section>

      <section className="py-28 md:py-40 text-center">
        <Container>
          <Reveal>
            <p className="font-serif italic text-gold/80 text-2xl">Every Stay. More Value.</p>
            <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
              <LuxeLink to="/apply" variant="solid">Request Consideration</LuxeLink>
              <LuxeLink to="/collection" variant="outline">View the Collection</LuxeLink>
            </div>
          </Reveal>
        </Container>
      </section>
    </div>
  );
}
